import { Navigate, Outlet } from 'react-router';
import { useMe } from './useMe';

export default function RequireAuth() {
  const { data, isPending, isError } = useMe();

  if (isPending) return <p className="p-6">Laden…</p>;
  if (isError) {
    return (
      <p role="alert" className="p-6">
        De planner is nu niet bereikbaar. Probeer het zo opnieuw.
      </p>
    );
  }
  if (!data) return <Navigate to="/login" replace />;
  return <Outlet />;
}
